module.exports = __webpack_public_path__ + "media/images/section-dedicated-033a990e28b1accefb4ab2266cac811d.jpg";